import React, { useState } from "react";
import "./Phone-Navbar.css";
import useCurrentPage from "../hooks/use-current-page.ts";

export const PhoneNavbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const pageIds = ["Home", "About", "Price", "Contact"];
  const currentPage = useCurrentPage(pageIds);

  const toggleMenu = () => setMenuOpen((prev) => !prev);

  const gotoPage = (id) => {
    setMenuOpen(false); // Close menu on selection
    document.getElementById(id).scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  };

  return (
    <div id="Phone-Navbar">
      {/* Hamburger Icon */}
      <div className="hamburger-icon" onClick={toggleMenu}>
        <span className={menuOpen ? "line selected" : "line"}></span>
        <span
          className={menuOpen ? "line second selected" : "line second"}
        ></span>
        <span className={menuOpen ? "line selected" : "line"}></span>
      </div>

      {/* Menu Content */}
      <div className={`phone-navbar-content ${menuOpen ? "open" : "closed"}`}>
        <div className={"space"}></div>
        {pageIds.slice(1).map((id) => (
          <p
            key={id}
            className={currentPage === id ? "selected" : ""}
            onClick={() => gotoPage(id)}
          >
            {id}
          </p>
        ))}
      </div>
    </div>
  );
};

export default PhoneNavbar;
